import { LocalStorageKey } from 'shared/entities/localStorage';
import { OnboardingStep, STEP_LS_KEYS } from 'shared/entities/onboarding';
import { localStorageHandler } from 'stores/localStorageHandler';

export const isOnboardingStepCompleted = (stepId: OnboardingStep): boolean =>
  localStorageHandler.getItem(STEP_LS_KEYS[stepId]) === 'true';

export const setOnboardingStepCompleted = (stepId: OnboardingStep): void => {
  localStorageHandler.setItem(STEP_LS_KEYS[stepId], 'true');
};

export const wasOnboardingQuickStartSent = (): boolean =>
  localStorageHandler.getItem(LocalStorageKey.onboardingQuickStartSent) ===
  'true';

export const setOnboardingQuickStartSent = (): void => {
  localStorageHandler.setItem(LocalStorageKey.onboardingQuickStartSent, 'true');
};

export const wasOnboardingFinishSent = (): boolean =>
  localStorageHandler.getItem(LocalStorageKey.onboardingFinishSent) === 'true';

export const setOnboardingFinishSent = (): void => {
  localStorageHandler.setItem(LocalStorageKey.onboardingFinishSent, 'true');
};
